export const model = {
    id: null,
    branch: "",
    tenant: "",
    dogNamber: ""
};
